export const FETCH_SHOPIFY_COLLECTIONS_REQUEST =
  "FETCH_SHOPIFY_COLLECTIONS_REQUEST";
export const FETCH_SHOPIFY_COLLECTIONS_SUCCESS =
  "FETCH_SHOPIFY_COLLECTIONS_SUCCESS";
export const FETCH_SHOPIFY_COLLECTIONS_FAILURE =
  "FETCH_SHOPIFY_COLLECTIONS_FAILURE";
